/** 线索来源预设（存入数据库 sourceText 的可选固定值，需与表单选项一致） */
export const LEAD_SOURCE_PRESET_VALUES = ['Yelp', '官网', '谷歌', 'Meta', '杂志']

/** 表单中表示「其它」的下拉值（不写入数据库） */
export const LEAD_SOURCE_OTHER = '__OTHER__'
